import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import { Table } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

import { 
    fetchRangePutting,
    getRangePutting,
    deleteRangePutting,
    fetchPlayerIntervention,
 } from 'Actions';

 import AddItem from '../../../../golf/rangeintervention/putting/component/addform';
 import UpdateItems from '../../../../golf/rangeintervention/putting/component/editform';

class PuttItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.confirmationDialog = React.createRef();
        this.state = {  
            student: this.props.data.student,  
            startdate:'',
            enddate:'', 
            listdiv:true,
            adddiv:false,
            alllstdiv1:false,
            
        };

        this.onPrevSection = this.onPrevSection.bind(this);
        this.onBacksection = this.onBacksection.bind(this); 
        this.onAddSession = this.onAddSession.bind(this);
        this.onListSession = this.onListSession.bind(this); 
        this.deleteForm = this.deleteForm.bind(this); 
    }

    onPrevSection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchRangePutting(student, stdate, eddate);
        this.setState({
            adddiv:false,
            alllstdiv1:false,
            listdiv:true, 
        }); 
    }

    onAddSession(e, id) {
        e.preventDefault();
		this.setState({ 
         selfrom:id,
         listdiv:false,
         adddiv:true,
      });
    }

    onListSession(e, id) {
        e.preventDefault();
        if(id==1){
            var sellst='alllstdiv1';
        }

		this.setState({ 
         sellst:id,   
         [sellst]:true,   
         listdiv:false,
         adddiv:false,
      });
    }

    onBacksection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchRangePutting(student, stdate, eddate);
        this.props.fetchPlayerIntervention(student, stdate, eddate);
        this.setState({ 
            alllstdiv1:false,  
            editdiv:false,
            adddiv:false,
            listdiv:true,
        });
    }

    editAssessment(gid){
        this.props.getRangePutting(gid).then((data) => {   
            var resdata=data.data;
            this.setState({ 
                eid:resdata[0].grpID,
                seldate:resdata[0].grp_date       
              });


            this.setState({ 
                alllstdiv1:false,               
                adddiv:false,
                editdiv:true,
       
              });

        });
    }

    deleteForm(data){
      this.data = data;
      this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            var stid=this.state.student;
            this.props.deleteRangePutting(this.data, stid);
            this.data = ""
        }
    }



render() {
      
    const { rangeputtinglist, loading} = this.props; 
    const stdrole = localStorage.getItem('stdrole');
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "date", label: "DATE" },
        { name: "coach", label: "COACH" },
        { name: "obsert", label: "OBSERVATION",
        options: {
            customBodyRender: (value) => {
            return <div style={{ whiteSpace: 'pre-wrap' }}>{value}</div>;
            }
        } },
        { name: "work", label: "WORK IN PROGRESS",
        options: {
            customBodyRender: (value) => {
            return <div style={{ whiteSpace: 'pre-wrap' }}>{value}</div>;
            }
        } },
        { name: "action", label: "ACTION" },
        { name: "action1", label: "ACTION1" },
      
    ];
    const tabledata=rangeputtinglist.map((assmntval,idx) => {     
                 const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.grpID)}><EditOutlinedIcon/></IconButton>;
                 const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.grpID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
            
            return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.grp_coachname,
            obsert:assmntval.grp_observation,
            work:assmntval.grp_workinprocess,
            action: ebtn,
            action1:dbtn,
            
            }
    });
      return(
            <div>
                

                {this.state.listdiv && 

                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="Report" chkbtn={stdrole==1? 0 :1 } addbtn onClickAdd={e => this.onAddSession(e, 1)} listbtn onClickList={e => this.onListSession(e, 1)} fullBlock>
                            <div className="table-responsive reporttable">
                                <Table hover bordered striped>
                                    <thead>
                                        <tr className="bg-primary text-white">
                                            <th>NO</th>
                                            <th>DATE</th>
                                            <th>COACH</th>
                                            <th>OBSERVATION</th>
                                            <th>WORK IN PROGRESS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rangeputtinglist.map((assmntval,idx) => {
                                            return (
                                                <tr>
                                                    <td>{idx+1}</td>
                                                    <td>{assmntval.cdate}</td>
                                                    <td>{assmntval.grp_coachname}</td>
                                                    <td style={{ whiteSpace: 'pre-wrap' }}>{assmntval.grp_observation}</td>
                                                    <td style={{ whiteSpace: 'pre-wrap' }}>{assmntval.grp_workinprocess}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table> 
                            </div>    
                        </RctCollapsibleCard>
                    </div>
                } 

                {this.state.alllstdiv1 &&      
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="List" backtoadd onClick={this.onPrevSection} fullBlock>
                        <MUIDataTable
                                
                                data={tabledata}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                }   

                {this.state.adddiv && 
                   <AddItem onClick={this.onPrevSection} data={this.state}/> 
                } 

                {this.state.editdiv && 

                <UpdateItems onClick={this.onBacksection} data={this.state}/>
                }

                <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'record'}
                />

            </div>

              
    )
   
}
 
}

const mapStateToProps = ({ rangeputting}) => {
   
    const { rangeputtinglist, loading } = rangeputting;
	return {  rangeputtinglist, loading };   
}


export default connect(mapStateToProps, {
    fetchRangePutting,
    getRangePutting,
    deleteRangePutting,
    fetchPlayerIntervention,
})(PuttItems);
